import { css, styled } from 'styles';
import { Icon } from 'components/elements/Icon';
import { rowBorderSize, rowExpanderCellWidth } from './Table.config';
import { BaseTableCell } from './TableCell.styled';
import { StyledTableRowCellsProps, StyledTableRowExpanderProps } from './types';

const highlightedStyle = css`
  background-color: ${({ theme }) => theme.table.highlight.background};
`;

const hoverStyle = css`
  &:hover {
    background-color: ${({ theme }) => theme.table.hover.background};
    color: ${({ theme }) => theme.table.hover.color};
  }
`;

const selectableStyle = css`
  cursor: pointer;
`;

const selectedStyle = css`
  background-color: ${({ theme }) => theme.table.select.background};
  color: ${({ theme }) => theme.table.select.color};

  svg {
    color: ${({ theme }) => theme.table.select.color};
  }
`;

export const TableRowCells = styled.div<StyledTableRowCellsProps>`
  align-items: stretch;
  border-radius: ${({ theme }) => theme.radius.small};
  display: flex;

  ${({ $highlighted, $selected }) => $highlighted && !$selected && highlightedStyle};
  ${({ $highlighted, $selected, $static }) =>
    !$highlighted && !$selected && !$static && hoverStyle};
  ${({ $selectable }) => $selectable && selectableStyle};
  ${({ $selected }) => $selected && selectedStyle};
`;

export const TableRowExpanderCell = styled(BaseTableCell)`
  justify-content: center;
  width: ${rowExpanderCellWidth}px;
`;

export const TableRowExpanderIcon = styled(Icon)<StyledTableRowExpanderProps>`
  font-size: 1.2em;
  opacity: ${({ $expanded }) => ($expanded ? 1 : 0.3)};
  transform: rotate(${({ $expanded }) => ($expanded ? 90 : 0)}deg);
  transition: opacity ${({ theme }) => theme.transition.fast} ease-out,
    transform ${({ theme }) => theme.transition.fast} ease-out;

  &:hover {
    opacity: 1;
  }
`;

export const StyledTableRow = styled.div`
  border-bottom: ${rowBorderSize}px solid ${({ theme }) => theme.table.border};
  display: flex;
  height: 0;
  flex-direction: column;
  left: 0;
  min-width: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  transition: background-color ${({ theme }) => theme.transition.fast} ease-out,
    color ${({ theme }) => theme.transition.fast} ease-out;
`;

TableRowCells.displayName = 'TableRowCells';
TableRowExpanderCell.displayName = 'TableRowExpanderCell';
TableRowExpanderIcon.displayName = 'TableRowExpanderIcon';
StyledTableRow.displayName = 'TableRow.Styled';
